import { Component } from '@angular/core';
import { Header } from '../../shared/horizontal-menu/horizontal-menu.component';

@Component({
  selector: 'app-smtpf',
  templateUrl: './smtpf.component.html',
  styleUrls: ['smtpf.component.scss']
})
export class SmtpfComponent {
  headerSmtpf = $localize`Smart-Metering Test Platform`;
  headerCls = $localize`CLS`;
  headerManufacturer = $localize`Manufacturer Tool`;

  headers: Header[] = [
    {
      headerText: $localize`Smart-Metering Test Platform`,
      path: 'smtpf',
      fragment: 'smtpf'
    },
    {
      headerText: $localize`CLS`,
      path: 'smtpf',
      fragment: 'cls'
    },
    {
      headerText: $localize`Manufacturer Tool`,
      path: 'smtpf',
      fragment: 'manufacturer-tool'
    },
  ];

  paragraphSmtpf = $localize`Die Smart-Metering Testplattform (SM-TPF) ist Teil des Vorhabens zur Steigerung der Interoperabilität des intelligenten Messsystems sowie zur Reduktion von Markteinführungszeiten. Es wird durch die SM-TPF sowohl für Konformitätsbewertungsstellen, als auch für CLS-Hersteller eine Möglichkeit geschaffen CLS auf TR-Konformität zu prüfen. Insbesondere den Herstellern soll dadurch die Migration auf neue TR-Versionen erleichtert werden. Durch die Möglichkeit des entwicklungsbegleitenden Testens kann der zeitintensive Entwicklungs- und Zertifizierungsaufwand für die Hersteller reduziert werden, als auch die Konformitätsbewertung durch das BSI dahingehend vereinfacht, dass bereits durchgeführte Konformitätsprüfungen des Herstellers als Ergebnisse in das Konformitätsbewertungsverfahren einfließen können. Ziel ist es den Nutzern eine Testplattform für eine Vorbereitung der Konformitätsprüfung in Anlehnung an die Technische Richtlinie zu ermöglichen.`;
  paragraphCls1 = $localize`Über die CLS-Schnittstelle des SMGW können steuerbare lokale Erzeuger und steuerbare intelligente Endgeräte (CLS) an das SMGW angeschlossen werden. Dafür baut der GWA z.B. für einen externen Marktteilnehmer (EMT) einen transparenten TLS-Kanal auf, über welchen individuelle Daten zwischen den angeschlossenen CLS und dem EMT ausgetauscht werden. Die SM-TPF prüft, ob der TLS-Kanal zwischen einem TR-konformen SMGW und einem CLS korrekt aufgebaut wird. In der Cloudanwendung der SM-TPF wird ein SMGW ausschließlich an den externen Schnittstellen simuliert, welches sich TR-konform verhält und eine CLS-Schnittstelle nachbildet. An diese Schnittstelle wird per HAN (Ethernet) das CLS angeschlossen. Die Testdurchführung wird durch den Nutzer via einer Benutzeroberfläche (WEB GUI) in einer Web-Applikation gesteuert.`;
  paragraphCls2 = $localize`Das BSI stellt Testfälle zum ersten Release Candidate der TR-03109-5 auf der Testplattform zur Verfügung. Darüber hinaus ist es dem Nutzer möglich eigene Testfälle innerhalb der Testplattform zu erstellen.`;
  paragraphCls3 = $localize`Der Nutzer kann das CLS an die Smart-Metering Testplattform anschließend und in dieser Testfälle durchführen. Über eine Benutzeroberfläche hat der Nutzer die Möglichkeit  mit der Testplattform zu interagieren.`;
  paragraphCls4 = $localize`Bei Bedarf kann ein Testbericht an das BSI geschickt werden. Darüber hinaus können Erfahrungen mit der Smart-Metering Community in einer eigenen Austauschplattform geteilt werden.`;
  paragraphCls5 = $localize`Die SM-TPF besteht aus zwei Modulen: Dem CLS-Interface, welches die Schnittstelle zum Testobjekt (CLS) darstellt und der Cloudanwendung inkl. Backend, welche die Schnittstelle zum Nutzer der SM-TPF darstellt.`;
  paragraphCls6 = $localize`Das CLS-Interface ermöglicht den Anschluss des CLS an die Testplattform. Das CLS-Interface kann über den Menüpunkt „Bestellung“.`;
  paragraphCls7 = $localize`Die Cloudanwendung wird vollständig in Deutschland auf dedizierten Servern betrieben. Das Informationssicherheits-Managementsystem des Betreibers erfüllt dabei die Anforderungen des Regelwerks ISO /IEC 27001 : 2013.`;
  paragraphManufacturer1 = $localize`Für das Testen von verschiedenen Fachanwendungsfällen bzw. Funktionalitäten eines entsprechenden CLS ist es notwendig Stimuli über die entsprechenden proprietären Inhaltsdaten auszulösen. Da jedoch das proprietäre Inhaltsdatenprotokoll eines zu testenden CLS nicht bekannt ist, wurde folgender Ansatz gewählt: Mit der Schnittstelle zum Hersteller-Tool wird eine interoperable Schnittstelle definiert, über welche die genannten Stimuli ausgelöst werden können. Der Hersteller eines CLS muss diese Schnittstelle implementieren (sofern das CLS anhand der SM-TPF mit CLS-Interface vollständig überprüft werden soll) und das Hersteller-Tool muss bei Ansteuerung durch die SM-TPF mit CLS-Interface die entsprechenden Stimuli mit den proprietären Protokollen im TLS-Kanal auslösen.`;
  paragraphManufacturer2 = $localize`Das Hersteller-Tool, welches die Schnittstelle anbietet, muss von der SM-TPF mit CLS-Interface erreicht werden können. Ebenso muss das Hersteller-Tool den TCP-CLS-Kanal der SM-TPF mit CLS-Interface erreichen können, um entsprechend seines proprietären Protokolls kommunizieren zu können.`;
  paragraphManufacturer3 = $localize`Die interoperable Schnittstelle des Hersteller-Tools ist als OpenAPI Spec Version 3 (OAS3) spezifiziert.`;
  paragraphManufacturer4 = $localize`The API is at: <a href="https://cls-api.smtpf.io" target="_blank">https://cls-api.smtpf.io</a> public reachable.`;

  smtpfInfo = [
    {
      text: $localize`The Federal Office for Information Security (BSI) publishes Technical Guidelines (TR) that set technical requirements for SMGW and CLS devices.`,
      icon: 'ballot',
      color: '#4c9cb4'
    },
    {
      text: $localize`The devices must undergo conformity tests to verify that they meet the TR requirements.`,
      icon: 'checklist_rtl',
      color: '#007194'
    },
    {
      text: $localize`Das entwicklungsbegleitende Testen ermöglicht Herstellern zeit- und kostenoptimiert die Konformitätsprüfung in Anlehnung an die Technische Richtlinie vorzubereiten.`,
      icon: 'speed',
      color: '#014459'
    },
  ];

  clsInfo = [
    {
      text: $localize`Control of the Test Platform via web application of the Smart-Metering Test Platform.`,
      color: '#99C6D4'
    },
    {
      text: $localize`Hosting environment according to ISO / IEC 27001 : 2013 certified.`,
      color: '#4c9cb4'
    },
    {
      text: $localize`Separate virtual machine per customer instance.`,
      color: '#007194'
    },
    {
      text: $localize`Use of several CLS interfaces in one instance and simultaneous test operation on several CLS interfaces possible.`,
      color: '#00607e'
    },
    {
      text: $localize`Zugriff auf eine Austauschplattform für die Smart-Metering-Community.`,
      color: '#014459'
    },
  ];
}
